import { memo, useMemo } from "react";
import { Chip, Paper, Stack, Typography } from "@mui/material";
import dayjs from "dayjs";
import "dayjs/locale/pt-br";
import type { AgendaSlotRow } from "../types";

/** Horários agrupados por dia: livre (destaque) ou bloqueado (apagado). */
export const AgendaSlotsList = memo(function AgendaSlotsList({ slots }: { slots: AgendaSlotRow[] }) {
  const days = useMemo(() => {
    const byDay = new Map<string, AgendaSlotRow[]>();
    slots.forEach((slot) => {
      const dayKey = dayjs(slot.start).format("YYYY-MM-DD");
      byDay.set(dayKey, [...(byDay.get(dayKey) || []), slot]);
    });
    return [...byDay.entries()];
  }, [slots]);

  return (
    <Stack spacing={1}>
      {days.map(([dayKey, daySlots]) => {
        const freeCount = daySlots.filter((slot) => slot.status === "free").length;
        return (
          <Paper key={dayKey} variant="outlined" sx={{ p: 1.5 }}>
            <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1, textTransform: "capitalize" }}>
              {dayjs(dayKey).locale("pt-br").format("dddd, DD/MM")} · {freeCount} livre{freeCount === 1 ? "" : "s"}
            </Typography>
            <Stack direction="row" flexWrap="wrap" useFlexGap gap={0.75}>
              {daySlots.map((slot) => {
                const isFree = slot.status === "free";
                return (
                  <Chip
                    key={slot.slotId}
                    size="small"
                    label={dayjs(slot.start).format("HH:mm")}
                    color={isFree ? "primary" : "default"}
                    variant={isFree ? "outlined" : "filled"}
                    title={isFree ? "Livre" : "Bloqueado"}
                    sx={{ opacity: isFree ? 1 : 0.6 }}
                  />
                );
              })}
            </Stack>
          </Paper>
        );
      })}
    </Stack>
  );
});
